/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCirclePlusFilled = createReactComponent("filled", "circle-plus-filled", "IconCirclePlusFilled", [["path", { "d": "M4.929 4.929a10 10 0 1 1 14.141 14.141a10 10 0 0 1 -14.14 -14.14zm8.071 4.071a1 1 0 1 0 -2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0 -2h-2v-2z", "key": "svg-0" }]]);

export { IconCirclePlusFilled as default };
//# sourceMappingURL=IconCirclePlusFilled.mjs.map
